import { GlamboxLocalStore } from "core/glambox/GlamboxLocalStore";

const UriList = {
  facebook: "https://www.facebook.com/sharer.php?u={{TEXT}}",
  instagram: "https://instagram.com/", 
  twitter: "http://twitter.com/share?text={{TEXT}}",
  whatsapp: "https://api.whatsapp.com/send?text={{TEXT}}"
};

export class ShareUtils {
  static ShareToCallback (social, text) {
    return () => {
      return ShareUtils.ShareTo(social, text);
    };
  }

  static ShareTo (social, text) {
    let template = UriList[social],
        url;
    
    if (typeof template === "undefined") return null;

    url = template.replace(/\{\{TEXT\}\}/g, text);

    if (url) {
      let dataLayerEvent = ShareUtils.CreateDataLayerEvent();

      ShareUtils.PushToDataLayer(
        dataLayerEvent,
        `convidar_${social}`
      );

      window.open(
        url, 
        "_blank",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600"
      );
    }
  }

  static CreateDataLayerEvent () {
    const localStore = new GlamboxLocalStore();
    return {
      utm_campaign: localStore.get("utm_campaign"),
      utm_source: localStore.get("utm_source"),
      utm_medium: localStore.get("utm_medium"),
      utm_content: localStore.get("utm_content")
    };
  }

  static PushToDataLayer (event, eventName) {
    if (typeof window !== "undefined") {
      let hostname = window.location.hostname;

      if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
          Object.assign(
            {},
            event,
            {
              event: eventName
            }
          )
        );
      }
    }
  }
}